export enum CountriesTypes {
  ADD_COUNTRY_SUCCESS = 'ADD_COUNTRY_SUCCESS',

  UPDATE_COUNTRY_SUCCESS = 'UPDATE_COUNTRY_SUCCESS',

  GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS',

  DELETE_COUNTRY_SUCCESS = 'DELETE_COUNTRY_SUCCESS',
}
